import { ABLoginManager } from '../lib/ab/login';
import { $el } from '../lib/ui/elements';
import { UIScreen } from '../lib/ui/screen';
import { UIViewSpec } from '../lib/ui/view';
import { $cdn } from '../lib/y/cdn';
import { $location } from '../lib/y/location';

export class AdminLoginScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        this.classList.add('scr-login');

        content.ui_add($el.IMG($cdn('images/logos/black.svg'), 'r-logo', 'Logo'));

        const manager = new ABLoginManager('admin', {
            no_forgot: true,
            on_success: () => {
                $location.navigate(['users', 'list']);
            }
        });
        manager.showLoginDialog();
    }
}
